export enum CountryCode {
  US = 'US',
  CA = 'CA',
  AU = 'AU',
  ES = 'ES',
}
